export default __webpack_public_path__ + "static/media/welcome-high-five.4941a9bb.svg";